import { render, staticRenderFns } from "./Calendary.vue?vue&type=template&id=4dd8bff6"
import script from "./Calendary.vue?vue&type=script&lang=js"
export * from "./Calendary.vue?vue&type=script&lang=js"
import style0 from "./Calendary.vue?vue&type=style&index=0&id=4dd8bff6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports